import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import apiConfig from 'src/api/APIConfig';
import { RootState } from 'src/store/index';
import moment from 'moment';

export const baseQueryUtils = fetchBaseQuery({
  baseUrl: apiConfig.appConfig.apiutils,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState).user?.user?.sponsorToken;
    const sponsor = ((getState() as RootState)?.user?.user as any)?.sponsor_sponsor_name;
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    if (sponsor) {
      headers.set('sponsor', sponsor);
    }
    headers.set('site_token', `${(getState() as RootState).user?.user?.siteToken}`);
    headers.set('user_date_time', moment().format());
    return headers;
  }
});

export const baseQueryETMFUtils = fetchBaseQuery({
  baseUrl: apiConfig.appConfig.apiutilsEtmf,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState).user?.user?.sponsorToken;
    const sponsor = ((getState() as RootState)?.user?.user as any)?.sponsor_sponsor_name;
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    if (sponsor) {
      headers.set('sponsor', sponsor);
    }
    headers.set('site_token', `${(getState() as RootState).user?.user?.siteToken}`);
    headers.set('user_date_time', moment().format());
    return headers;
  }
});

export const baseQueryISFUtils = fetchBaseQuery({
  baseUrl: apiConfig.appConfig.apiutilsIsf,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState).user?.user?.token;
    const sponsor = ((getState() as RootState)?.user?.user as any)?.sponsor_sponsor_name;
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    if (sponsor) {
      headers.set('sponsor', sponsor);
    }
    headers.set('sponsor_token', `${(getState() as RootState).user?.user?.sponsorToken}`);
    headers.set('user_date_time', moment().format());
    return headers;
  }
});
